import { render } from "./Zonas.vue?vue&type=template&id=12df8e54"
import script from "./Zonas.vue?vue&type=script&lang=js"
export * from "./Zonas.vue?vue&type=script&lang=js"

import "./Zonas.vue?vue&type=style&index=0&id=12df8e54&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__